var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowRight02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_57216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7556 16.111L11.4232 24.7469C11.3458 24.8272 11.2539 24.8908 11.1527 24.9342C11.0516 24.9776 10.9432 25 10.8337 25C10.7242 25 10.6158 24.9776 10.5147 24.9342C10.4135 24.8908 10.3216 24.8272 10.2442 24.7469C10.1668 24.6667 10.1054 24.5714 10.0635 24.4666C10.0216 24.3618 10 24.2494 10 24.1359C10 24.0225 10.0216 23.9101 10.0635 23.8053C10.1054 23.7004 10.1668 23.6052 10.2442 23.5249L17.9881 15.5L10.2442 7.47506C10.0878 7.31302 10 7.09324 10 6.86407C10 6.63491 10.0878 6.41513 10.2442 6.25308C10.4005 6.09104 10.6126 6 10.8337 6C11.0548 6 11.2669 6.09104 11.4232 6.25308L19.7556 14.889C19.8331 14.9692 19.8946 15.0645 19.9365 15.1693C19.9784 15.2741 20 15.3865 20 15.5C20 15.6135 19.9784 15.7259 19.9365 15.8307C19.8946 15.9355 19.8331 16.0308 19.7556 16.111Z",
    fill: "#B3B8C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_57216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight02);
export default __webpack_public_path__ + "static/media/icon_arrow_right02.eda92e2ec369cbd10e1a9af3c5c8999f.svg";
export { ForwardRef as ReactComponent };